import { useTranslation } from "react-i18next";

import styles from "./AssignedAgent.module.scss";

interface Props {
  agent: {
    name: string;
    letter?: string;
    color?: string;
  } | null;
}

const AssignedAgent = ({ agent }: Props) => {
  const { t } = useTranslation();
  if (!agent) {
    return (
      <div className={styles.row}>
        <span className={styles.unassigned}>{t("Unassigned")}</span>
      </div>
    );
  }

  return (
    <div className={styles.row}>
      <span className={styles.name}>{agent.name}</span>
    </div>
  );
};

export default AssignedAgent;
